export default {"src":"/_next/static/media/target.6cd491af.svg","height":75,"width":76,"blurWidth":0,"blurHeight":0};